<div class="recover-password-alliance content-without-footer d-flex">
    <app-sprintpay-password-recovery
        class="position-absolute"
        [widthLogo]="'156'"
        [heightLogo]="'113'"
    ></app-sprintpay-password-recovery>
</div>
